<!-- /**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 */ -->
<template>
  <div>
    <v-row v-if="model && model.idPatient">
      <v-col cols="12" md="12" sm="12">
        <patient-information :model="model" />
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <Patient-consultation-info :model="model" />
      </v-col>
    </v-row>
    <br />
    <v-row class="mt-2 mb-2">
      <v-expansion-panels v-model="panelSV" >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3>Somatometría</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col cols="12" md="12" sm="12">
              <patient-somatometry :model="model" :suimFlag="suimFlag" />
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <!-- <patient-antecedents :model="model" /> -->
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-divider></v-divider>
      <div class="separator20-50"></div>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <PersonalAntecedentsToAudiometry
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-5" v-if="fullInfoEars">
        <h3 align="left">Sintomatología:</h3>
        <!-- <GraphAudiometry :chartData="chartData" /> -->
        <Symptoms
          :model="model"
          :bothEars="bothEars"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <h3 align="left">Otoscopia:</h3>
        <span>En caso de no aplicar revisión colocar N/D.</span>
        <Otoscopy :model="model" :isViewDetailsForm="isViewDetailsForm" />
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-5" v-if="fullInfoEars">
        <h3 align="left">Resultados del examen:</h3>
        <TestResultAudiometry
          :model="model"
          :toUpdateTable="toEdit"
          :takePictureAudiometry="takePictureAudiometry"
          :rightEar="rightEar"
          :leftEar="leftEar"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <h3 align="left">Interpretación de audiometría:</h3>
        <AudiometryInterpretation
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <h3 align="left">Nota médica:</h3>
        <br />
        <v-row class="mb-5">
          <v-col
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Nota médica"
              rules="required"
            >
              <vue-editor
                v-model="model.content"
                :errors-message="errors"
                required
                :disabled="isViewDetailsForm"
                @input="onEditorInput"
              />
              <span class="error--text">{{ errors.toString() }}</span>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <PatientCIE10Component
          :model="model"
          :saveCie10Changes="saveCie10Changes"
          :isViewDetailsForm="isViewDetailsForm"
          :isUpdate="true"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientConsultationInfo from "@/app/components/common/patient/PatientConsultationInfo.vue";
import PatientSomatometry from "@/app/components/common/patient/PatientSomatometry.vue";
import PersonalAntecedentsToAudiometry from "@/app/components/optometry/common/PersonalAntecedentsToAudiometry.vue";
import Symptoms from "@/app/components/audiometry/common/Symptoms.vue";
import Otoscopy from "@/app/components/audiometry/common/Otoscopy.vue";
import AudiometryInterpretation from "@/app/components/audiometry/common/AudiometryInterpretation.vue";
import GraphAudiometry from "@/app/components/audiometry/common/GraphAudiometry.vue";
import TestResultAudiometry from "@/app/components/audiometry/common/TestResultAudiometry.vue";
import { VueEditor } from "vue2-editor";
import PatientCIE10Component from "@/app/components/common/patient/PatientCIE10Component.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { AudiometryComponentsService } from "@/app/services";
export default {
  props: {
    model: Object,
    idMedicalPractice: String,
    saveCie10Changes: Boolean,
    isViewDetailsForm: Boolean,
    takePictureAudiometry: Boolean,
  },
  components: {
    PatientInformation,
    PatientSomatometry,
    PatientCIE10Component,
    PatientConsultationInfo,
    VueEditor,
    ValidationProvider,
    ValidationObserver,
    Symptoms,
    Otoscopy,
    AudiometryInterpretation,
    PersonalAntecedentsToAudiometry,
    GraphAudiometry,
    TestResultAudiometry,
  },
  data() {
    return {
      panelSV: 0,
      suimFlag: 1,
      toEdit: true,
      rightEar: {},
      leftEar: {},
      fullInfoEars: false,
      bothEars: {},
    };
  },
  created() {
    this.model.idHumanResource = this.$utilFront.getIdHumanResource();
    this.listAllEars();
  },
  methods: {
    listAllEars() {
      AudiometryComponentsService.audiometryBodyParts().then((res) => {

        this.bothEars = [];

        if(this.$utilFront.nonEmptyList(res.data)){
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            switch (element.acronym) {
              case "OD":
                this.bothEars.push(element);
                this.rightEar = element;
                break;
              case "OI":
                this.bothEars.push(element);
                this.leftEar = element;
                break;
            }
          }
        }


        // this.bothEars = res.data.map((part) => {
        //   switch (part.idBodyPart) {
        //     case 4:
        //       return {
        //         acronym: part.acronym,
        //         idBodyPart: part.idBodyPart,
        //         name: part.name,
        //         numberParts: part.numberParts,
        //       };
        //       break;
        //     case 5:
        //       return {
        //         acronym: part.acronym,
        //         idBodyPart: part.idBodyPart,
        //         name: part.name,
        //         numberParts: part.numberParts,
        //       };
        //       break;
        //   }
        // });
        // res.data.map((part) => {
        //   switch (part.idBodyPart) {
        //     case 4:
        //       this.rightEar = part;
        //       break;
        //     case 5:
        //       this.leftEar = part;
        //       break;
        //   }
        // });

        this.fullInfoEars = true;
      });
    },
    onEditorInput(html) {
      const plain = html.replace(/<[^>]*>/g, '')
      if (!plain.trim()) {
        this.model.content = ''
      } else {
        this.model.content = html
      }
    },
    // listAllEars() {
    //   AudiometryComponentsService.audiometryBodyParts().then((res) => {
    //     this.bothEars = res.data.map((part) => {
    //       switch (part.idBodyPart) {
    //         case 4:
    //           return {
    //             acronym: part.acronym,
    //             idBodyPart: part.idBodyPart,
    //             name: part.name,
    //             numberParts: part.numberParts,
    //           };
    //           break;
    //         case 5:
    //           return {
    //             acronym: part.acronym,
    //             idBodyPart: part.idBodyPart,
    //             name: part.name,
    //             numberParts: part.numberParts,
    //           };
    //           break;
    //       }
    //     });
    //     res.data.map((part) => {
    //       switch (part.idBodyPart) {
    //         case 4:
    //           this.rightEar = part;
    //           break;
    //         case 5:
    //           this.leftEar = part;
    //           break;
    //       }
    //     });
    //     this.fullInfoEars = true;
    //   });
    // },
  },
};
</script>
